import {useListView} from '../../core/ListViewProvider'
import {EmbeddignsListToolbar} from './EmbeddignsListToolbar'
import {EmbeddignsListGrouping} from './EmbeddignsListGrouping'
import {EmbeddingsListSearchComponent} from './EmbeddingsListSearchComponent'

interface ScrappingListHeaderProps {
  handletableLoading : (value:boolean) => void,
  setDataHandler : (value:string) => void
}
const ScrappingListHeader: React.FC<ScrappingListHeaderProps> = ({handletableLoading,setDataHandler}) => {
  const {selected} = useListView()
  return (
    <div className=''>
      {/* <EmbeddingsListSearchComponent /> */}
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <EmbeddignsListGrouping handletableLoading={handletableLoading} setDataHandler={setDataHandler}/> : <EmbeddignsListGrouping handletableLoading={handletableLoading} setDataHandler={setDataHandler}/> }
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {ScrappingListHeader}
